import { pick } from 'lodash';
import { mapState } from 'vuex';

export default {
  props: {
    showOnlySearchesForEntity: String,
  },
  computed: {
    ...mapState({
      searches: state => state.searcher.savedSearches,
    }),
    /**
     * @return {Object<string, Object[]>}
     */
    groupedSearches() {
      const groupedSearches = this.searches.reduce((result, search) => {
        const group = search.searcher;
        result[group] = result[group] || [];
        result[group].push(search);
        return result;
      }, {});

      if (this.showOnlySearchesForEntity) {
        return pick(groupedSearches, this.showOnlySearchesForEntity);
      }

      return groupedSearches;
    },
    hasSearches() {
      return Object.keys(this.groupedSearches).length > 0;
    },
    emptyMessage() {
      if (this.searches.length === 0) {
        return this.$t('message.searcher.savedSearch.empty');
      }
      if (this.showOnlySearchesForEntity
        && !this.hasSearches
      ) {
        return this.$t('message.searcher.savedSearch.currentEntityEmpty', {
          entity: this.$t(`message.searcher.tab.${this.showOnlySearchesForEntity}`),
        });
      }
      return '';
    },
  },
};
